<template>
    <div>
      <div class="cover-layer"></div>
        <ul ref="sp" v-if="$t('language.name')=='English'">
            <li><span @click="select(0)">不限</span></li>
            <li v-for="item in 8">
                <span v-if="item!=8" @click="select(item)">{{item}}人</span>
                <span v-if="item==8" @click="select(item)">{{item}}人</span>
            </li>
        </ul>
        <ul ref="sp" v-else>
        <li><span @click="select(0)">No restriction</span></li>
        <li v-for="item in 8">
            <span v-if="item!=8" @click="select(item)">{{item}} People</span>
            <span v-if="item==8" @click="select(item)">{{item}} People</span>
        </li>
    </ul>
    </div>
</template>

<script>
    export default {
        name: "SelectPeople",
        data: function () {
            return {}
        },
        mounted() {
          this.addCloseListener()
        },
        methods: {
          select(val){
            this.$emit('select',val)
          },
          addCloseListener() {
            let that = this;
            document.addEventListener('click', function (e) {
              if (e.target.className == 'pnum' || that.$refs.sp && that.$refs.sp.contains(e.target)) return;
              that.$emit('select')
            })
          }
        }
    }
</script>

<style scoped>
  ul{
    width: 224px;
    background: #fff;
    height: 205px;
    box-shadow: 0 0 5px rgba(0,0,0,0.4);
    overflow: hidden;
  }
  ul li{
    line-height: 20px;
    border-bottom: 1px solid #ccc;
    cursor: pointer;
  }
  ul li span{
    width: 100%;
    height: 100%;
    display: inline-block;
    padding: 10px 30px;
  }
  ul li:hover{
    background: #28c667;
    color: #fff;
  }
  ul li:hover span{
    color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/common/cmpnt/selectPeople/SelectPeople.vue